import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  homeBranchData: null,
};

export const getHomeBranch = createAsyncThunk(
  "homebranch/geth",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get(`home/branch-locator`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const branchLocatorSlice = createSlice({
  name: "homebranch",
  initialState,
  reducers: {},
  extraReducers: {
    [getHomeBranch.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getHomeBranch.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.homeBranchData = action.payload?.data;
    },
    [getHomeBranch.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default branchLocatorSlice.reducer;
